import { AnswerResult } from "../../../../store/viewmodels/AnswerViewModel";
import { getDurationInSeconds } from "../../../utils/DateServices";

interface FindErrorResultItemProps {
    answer: AnswerResult,
}

function FindErrorResultItem(props: FindErrorResultItemProps): JSX.Element {
    const answerText = props.answer.value === "true" ? "tosi" : "epätosi";
    const start = new Date(Date.parse(props.answer.start_time));
    const end = new Date(Date.parse(props.answer.end_time));
    const answerDuration = getDurationInSeconds(end, start);

    const questionText = props.answer.item.content;

    const answer = <span className="text-center my-auto pb-1" key={"answer-" + props.answer.id}>{answerText}</span>;
    const answerTime = <span className="text-center my-auto pb-1" key={"answerTime-" + props.answer.id}>{answerDuration + ' s'}</span>
    const question = <span className="text-center my-auto pb-1" key={"question-" + props.answer.id}>{questionText}</span>;
    const symbol = props.answer.value === props.answer.item.correct ?
        <span className="ri-check-line text-green-500 text-center my-auto pb-1" key={"symbol-" + props.answer.id}></span> :
        <span className="ri-close-line text-red-500 text-center my-auto pb-1" key={"symbol-" + props.answer.id}></span>;

    return (
        <div className="grid grid-cols-5">
            <div className="col-span-2">{question}</div>
            <div className="ml-5">{answer}</div>
            <div className="text-center font-bold">{symbol}</div>
            <div className="text-center">{answerTime}</div>
        </div>
    );
}

export default FindErrorResultItem;